module.exports = __webpack_public_path__ + "img/turksAndCaicos 2.7184f611.png";